/* Constants not for redux */
//@flow

export const _PENDING_REFUND = [
  "PENDING_REFUND",
  "Menunggu Proses refund",
  "Refund process"
];
export const _PENDING_PAYMENT = [
  "PENDING",
  "Menunggu Pembayaran",
  "Awaiting Payment"
];
export const _VERIYING_PAYMENT = [
  "VERIFYING_PAYMENT",
  "Pembayaran Diproses",
  "Awaiting Payment Approval"
];
export const _ON_CANCEL = [
  "CANCELLED",
  "Transaksi Dibatalkan",
  "Cancelled",
  "Failed"
];
export const _NEW = [
  "NEW",
  "Menunggu Konfirmasi Seller",
  "Awaiting seller confirmation"
];
export const _SELLER_SENT = [
  "SELLER_SENT",
  "Menunggu Pengiriman Dari Seller",
  "En route to Kick Avenue"
];
export const _KA_RECEIVED = [
  "KA_RECEIVED",
  "Authentication Process",
  "In Progress"
];
export const _KA_RETURN = [
  "KA_RETURNED_SELLER",
  "Proses Pengembalian Ke Seller",
  "Product is shipped back to you"
];
export const _VERIFIED_PASS = [
  "VERIFICATION_PASSED",
  "Proses Otentikasi Berhasil",
  "Authentication process - SUCCESS",
  "In Progress"
];
export const _VERIFIED_FAIL = [
  "VERIFICATION_FAILED",
  "QC Failed",
  "Authentication process - FAILED",
  "Verification Failed"
];
export const _SENT_BUYER = [
  "KA_SENT_BUYER",
  "Sneaker Telah Diterima",
  "Delivery to Customer",
  "In Progress"
];
export const _DONE_BY_BUYER = "DONE_BY_BUYER";
export const _DONE_BY_ADMIN = "DONE_BY_ADMIN";
export const _DONE_BY_CRON = "DONE_BY_CRON";
export const _COMPLETED = "COMPLETED";

export const _REFUNDED = [
  "REFUNDED",
  "Proses Refund Selesai Diproses",
  "Refund completed"
];
export const _REJECTED = ["REJECTED"];

export const ON_COURIER = [
  "Dalam Pengiriman ke Kickavenue",
  "Awaiting your shipping confirmation",
  "En route to Kick Avenue",
  "Waiting For Seller To Deliver"
];
export const ON_DONE = ["Proses Selesai", "Delivered"];
export const REJECT = "REJECT";
export const EXPIRED = [
  "EXPIRED",
  "Waktu Pembayaran Telah Habis",
  "Expired payment"
];
export const ADMINISTRATOR: string[] = [
  "CONTACT Whatsapp",
  "Please contact our Customer Service"
];

export const BANK_TRANSFER = ["bank_transfer", "BANK TRANSFER"];
export const VIRTUAL_ACC = ["virtual_account", "VIRTUAL ACCOUNT"];
export const CREDIT_CARD = ["credit_card", "CREDIT CARD"];
export const KREDIVO = ["kredivo", "KREDIVO"];
export const AKULAKU = ["akulaku", "AKULAKU"];
export const ATOME = ["atome", "ATOMEID"];
export const GOPAY = ["gopay", "GOPAY"];

export const TRANSACTION = "TRANSACTION";
export const NAME = "NAME";
export const SIZE = "SIZE";
export const PRICE = "PRICE";
export const STATUS = "STATUS";
export const METHOD_PAYMENT = "METHOD_PAYMENT";

export const VOUCHER_PRODUCT_TYPE = "product_price";
export const VOUCHER_COURIER_TYPE = "courier_price";
export const VOUCHER_TYPES = [
  VOUCHER_PRODUCT_TYPE,
  VOUCHER_COURIER_TYPE
];

const APPROVED = "approved";
const DISBURSEMENT = ["PROSES DISBURSEMENT", "Disbursement process"];
const ORDER_MASUK = ["ORDER MASUK", "Order received"];
const WAREHOUSE = [
  "MENUNGGU PENERIMAAN di WAREHOUSE",
  "En route to Kick Avenue"
];
const CONSUMENT_SENT = [
  "PENGIRIMAN KE KONSUMEN",
  "Product is being delivered",
  "Delivering to you"
];
const LISTING = [
  "LISTING AKTIF",
  "LISTING TDK AKTIF",
  "LISTING EXPIRING",
  "LISTING EXPIRED"
];
const SELL_DONE = "PENJUALAN SELESAI";
const RESERVATION = "DALAM RESERVASI";
const WAIT_CONFIRM = [
  "awaiting_review",
  "MENUNGGU KONFIRMASI",
  "Awaiting review"
];
const WAIT_CONSIGN = [
  "awaiting_consignment",
  "AWAITING CONSIGNMENT",
  "Awating product consignment"
];
const UNDER_REVIEW = ["under_review", "PROSES REVIEW", "In review"];
const REJECTED = ["rejected", "PENGAJUAN ANDA DITOLAK", "Rejected"];
const SENT_KICK = [
  "Delivery to Kick Avenue",
  "En route to Kick Avenue"
];
const CANCELLED = ["cancelled", "DI BATALKAN", "Cancelled"];
const MORE_INFO = [
  "more_info",
  "Info Tidak Lengkap",
  "Incomplete information"
];
const DRAFT = [
  "draft",
  "UPLOAD BERMASALAH, HUBUNGI WHATSAPP: +6281210005425",
  "Draft"
];
const SUSPEND = "rescinded";
const REQUEST_TO_BE_SELLER =
  "Harap masukkan nomor telfon anda untuk melanjutkan";
const NEW_REQUEST_TO_BE_SELLER = "SELL WITH US!";
const HIJACKED = "hijacked";

/*KONDISI BOX*/
const SEMPURNA = ["SEMPURNA", "Sempurna", "Perfect Box"];
const CACAT = ["CACAT", "Damaged Box"];
const NO_BOX = ["NO_BOX", "Missing Box"];
/*KONDISI SNEAKER*/
const BARU = ["BARU", "Baru", "Brand New"];
const BEKAS = ["BEKAS", "Bekas", "Used"];

//offer
export const ACCEPTED_OFFER = ["ACCEPTED", "ACCEPTED OFFER"];
export const _VERIFYING_BID = [
  "VERIFYING_BID",
  "Menunggu Pembayaran",
  "Awaiting Payment"
];

const SET_LOGIN_REFERRAL = "SET_LOGIN_REFERRAL";

const SHOW_TRIGGER_DOWNLOAD_MODAL = "SHOW_TRIGGER_DOWNLOAD_MODAL";

const APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || null;

export {
  APPROVED,
  DISBURSEMENT,
  ORDER_MASUK,
  WAREHOUSE,
  CONSUMENT_SENT,
  LISTING,
  SELL_DONE,
  RESERVATION,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  UNDER_REVIEW,
  REJECTED,
  SENT_KICK,
  CANCELLED,
  HIJACKED,
  DRAFT,
  MORE_INFO,
  SUSPEND,
  SEMPURNA,
  CACAT,
  NO_BOX,
  BARU,
  BEKAS,
  REQUEST_TO_BE_SELLER,
  SET_LOGIN_REFERRAL,
  NEW_REQUEST_TO_BE_SELLER,
  APP_ID,
  SHOW_TRIGGER_DOWNLOAD_MODAL
};
